import React, { useCallback, useState } from 'react';
import { CustomStepper } from '@blumtechgroup/blum-react-core-components';
import { LicenceType, validationErrors, ValidationErrors, LicenseTypeReducerAction } from '../..';
import StepDetails from '../StepDetails';
import StepReview from '../StepReview';
import { Types } from '@blumtechgroup/blum-ui-utils';

interface Props {
  completeLabel: string;
  licenseType: LicenceType;
  dispatch: React.Dispatch<{ type: LicenseTypeReducerAction; value: any }>;
  handleSave: () => void;
}

const LicenseTypeSteps = ({ completeLabel, licenseType, dispatch, handleSave }: Props): React.ReactElement => {
  const [step, setStep] = useState<number>(0);

  const [errors, setErrors] = useState<ValidationErrors>({
    name: false,
  });

  const validate = useCallback(
    (_step: number) => {
      const errorItems: Types.UnknownObject = {};
      if (_step === 0) {
        errorItems.name = !licenseType.name ? validationErrors.name : false;
      }
      setErrors({ ...errors, ...errorItems });
      return (Object.keys(errorItems) as Array<keyof typeof validationErrors>).some((i) => errorItems[i]);
    },
    [licenseType, errors]
  );

  return (
    <CustomStepper
      step={step}
      isNextDisabled={(Object.keys(errors) as Array<keyof typeof errors>).some((i) => errors[i])}
      completeLabel={completeLabel}
      setStep={setStep}
      validate={validate}
      handleComplete={handleSave}
      gridSize={6}
      stepperSteps={[
        {
          label: 'Details',
          component: <StepDetails licenseType={licenseType} errors={errors} setErrors={setErrors} dispatch={dispatch} />,
        },
        {
          label: 'Summary',
          component: <StepReview licenseType={licenseType} setStep={setStep} />,
        },
      ]}
    />
  );
};

export default LicenseTypeSteps;
